import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';
import _get from 'lodash/get';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './BundleChildTitle.css';

const cx = classNames.bind(styles);

const bundleProductdetails = (bundleProductDetails) =>
    bundleProductDetails &&
    bundleProductDetails.map((bundleProduct) => (
        <li className={dt(['list-disc'])}>{_get(bundleProduct, 'product.name', '')}</li>
    ));

const BundleChildTitle = (props) => {
    const { productDetails } = props;
    const titleListStyle = dt([
        'font-open-sans',
        'text-xs',
        'font-open-sans-regular',
        'text-black',
        'mt-4',
    ]);
    return (
        <section className={titleListStyle} data-automation-id="bundle-product-details">
            <ul className={dt(['ml-5', 'leading-5'])}>
                {productDetails && productDetails.products
                    ? bundleProductdetails(productDetails.products)
                    : ''}
            </ul>
        </section>
    );
};

BundleChildTitle.propTypes = {
    productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

BundleChildTitle.defaultProps = {
    productDetails: {},
    selectedStore: {},
};

export default BundleChildTitle;
